import React from 'react'

export const KONAMI_CODE = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]

export class EasterEgg extends React.Component {
  state = { index: 0 }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = event => {
    const { callback, disable, code } = this.props
    const sequence = code || KONAMI_CODE

    if (this.state.index < sequence.length) {
      let nextIndex

      if (event.keyCode === sequence[this.state.index]) {
        nextIndex = this.state.index + 1
      } else {
        nextIndex = 0
      }

      this.setState({ index: nextIndex })

      if (!disable && nextIndex === sequence.length) {
        callback && callback()
        this.setState({ index: 0 })
      }
    }
  }

  render() {
    return null
  }
}

export default EasterEgg



// WEBPACK FOOTER //
// ./src/components/Konami.js